import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nft-card-back-pay" }
const _hoisted_2 = { class: "text-area" }
const _hoisted_3 = { class: "date-row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "row-line" }, null, -1)
const _hoisted_5 = { class: "sub-text" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "row-line" }, null, -1)
const _hoisted_7 = { class: "main-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('nftCard.monthUse', [_ctx.month])), 1),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.info.monthPrice) + " " + _toDisplayString(_ctx.$t(_ctx.unit)), 1)
    ])
  ]))
}